'use client';

import { IconPlusWhite } from "@/assets";
import { Buttons } from "@/components";
import { useAuth } from "@/provider/UserProvider";
import { useDisclosure } from "@nextui-org/react";
import { toast } from "react-toastify";
import GenerateModal from "./GenerateModal";
import ListMyKey from "./ListMyKey";
import useFetch from "./useFetch";

const ApiKeyContent = () => {
  const { isOpen, onOpenChange, onOpen } = useDisclosure();
  const { isLoginClient } = useAuth();
  const { list, getData, loading } = useFetch();
  
  const onGenerate = () => {
    if (!isLoginClient) return toast.warning('Please login to continue!');
    onOpen();
  }

  return (
    <div className="mt-10">
      <div className="main-container">
        <div className="flex gap-10">
          <div>
            <h1 className="font-semibold text-[24px] mb-2 sm:text-[20px]">API Keys</h1>
            <div className="text-gray-500 sm:text-[14px] max-w-[1170px] leading-[1.7]">
              As an owner of this project, you can view and manage all API keys in this project. <br />
              Do not share your API key with others, or expose it in the browser or other client-side code. In order to protect the security of your account, 
              aiRight may also automatically disable any API key that has leaked publicly.
            </div>
          </div>
          <div aria-checked={list.length > 0} className="hidden aria-checked:block sm:aria-checked:hidden">
            <Buttons onClick={onGenerate}>
              <div className="flex items-center font-medium">
                <IconPlusWhite className="scale-80" /> Generate API Key
              </div>
            </Buttons>
          </div>
        </div>
        <div aria-checked={list.length > 0} className="mt-5 aria-checked:hidden sm:aria-checked:block">
          <Buttons onClick={onGenerate}>
            <div className="flex items-center font-medium sm:text-[13px]">
              <IconPlusWhite className="scale-80" /> Generate API Key
            </div>
          </Buttons>
        </div>
        {list.length > 0 && (
          <ListMyKey getData={getData} list={list} loading={loading} />
        )}
      </div>
      <GenerateModal 
        callback={getData}
        isOpen={isOpen}
        onOpenChange={onOpenChange}
      />
    </div>
  );
}

export default ApiKeyContent;
